import { HEAT_TIERS, FLAME } from "@shared/heat";
import { cn } from "@/lib/utils";

// Canonical heat picker. Stores one ordinal level (1-5); each option surfaces
// the flame count, tier name, and Scoville range together so a seller can pick
// by whichever framing they think in. Reused by the listing form and the
// one-time retro prompt so the scale never drifts between them.
export function HeatPicker({
  value,
  onChange,
}: {
  value: number | null;
  onChange: (level: number) => void;
}) {
  return (
    <div className="space-y-2">
      {HEAT_TIERS.map((tier) => {
        const selected = value === tier.level;
        return (
          <button
            key={tier.level}
            type="button"
            onClick={() => onChange(tier.level)}
            aria-pressed={selected}
            className={cn(
              "flex w-full items-center gap-3 rounded-xl border p-3 text-left transition-colors",
              selected
                ? "border-primary bg-primary/10"
                : "border-border bg-background hover:border-primary/40",
            )}
          >
            <span className="w-24 shrink-0 text-base leading-none tracking-tight">
              {tier.level === 0 ? (
                <span className="text-xs text-muted-foreground">None</span>
              ) : (
                FLAME.repeat(tier.level)
              )}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold text-foreground">{tier.name}</span>
              <span className="block text-xs text-muted-foreground">
                {tier.scovilleLabel} · {tier.peppers}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
